import CustomModal from "../Customs/CustomModal";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { IconButton } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import axios from "axios";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Link, useNavigate } from "react-router-dom";
import FxModalProductEdit from "./FxModalProductEdit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import Loading from "../Loading/Loading";
import { useMessage } from "../MessageProvider/MessageProvider";
import { Tooltip } from "antd";
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
export default function DetailedModal({
  openStatByModal,
  setOpenStatByModal,
  personBy,
  dataDetail,
}) {
  const elementRef = React.useRef(null);
  let [openProductEdit, setOpenProductEdit] = React.useState(false);
  const messageApi = useMessage();
  let [editableProduct, setEditAbleProduct] = React.useState(null);
  let [openAddSum, setOpenAddSum] = React.useState(false);
  let [loading, setLoading] = React.useState(false);
  let [data, setData] = React.useState(dataDetail);
  let [addSum, setAddSum] = React.useState(null);
  let [person, setPerson] = React.useState(null);
  let [openPersonEdit, setOpenPersonEdit] = React.useState(false);
  let [userNameEdit, setUserNameEdit] = React.useState(false);

  React.useEffect(() => {
    setData(dataDetail);
    setUserNameEdit(dataDetail?.name);
  }, [dataDetail]);

  let getSinglePerson = async () => {
    try {
      // setDataDetail;
      setLoading(true);

      let token = localStorage.getItem("token");
      let info = await axios.get(
        process.env.REACT_APP_API_URL + "/api/register/" + data.id,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      console.log("info.data");
      console.log(info.data);
      if (info.data.success) {
        setPerson(info.data);
        setData(info.data.customer);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  let AddToSumFunc = async () => {
    try {
      setLoading(true);
      let token = localStorage.getItem("token");
      let info = await axios.post(
        process.env.REACT_APP_API_URL + "/api/summa_bergan",
        {
          summa_bergan: addSum,
          customer_id: data?.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(info.data);
      if (info.data.success) {
        setAddSum("");
        getSinglePerson();
        setOpenAddSum(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFullscreen = () => {
    if (elementRef.current.requestFullscreen) {
      elementRef.current.requestFullscreen();
    } else if (elementRef.current.mozRequestFullScreen) {
      /* Firefox */
      elementRef.current.mozRequestFullScreen();
    } else if (elementRef.current.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elementRef.current.webkitRequestFullscreen();
    } else if (elementRef.current.msRequestFullscreen) {
      /* IE/Edge */
      elementRef.current.msRequestFullscreen();
    }
  };

  const handlePrint = () => {
    const printContent = elementRef.current;
    const WinPrint = window.open("", "", "width=900,height=650");
    WinPrint.document.write("<html><head><title>Print</title>");
    WinPrint.document.write(
      "<style>@media print { body { -webkit-print-color-adjust: exact; } table { width: 100%; border-collapse: collapse; } th, td { border: 1px solid black; padding: 10px; } }</style>"
    );
    WinPrint.document.write("</head><body>");
    WinPrint.document.write(printContent.innerHTML);
    WinPrint.document.write("</body></html>");
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };

  return (
    <CustomModal openModal={openStatByModal}>
      {/* edit */}
      <FxModalProductEdit
        personBy={personBy}
        openProductEdit={openProductEdit}
        setOpenProductEdit={setOpenProductEdit}
        editableProduct={editableProduct}
        setEditAbleProduct={setEditAbleProduct}
        person={person}
        getSinglePerson={getSinglePerson}
      />
      <div className=" w-[98%] py-[10px] my-0 m-auto">
        <div className="w-[100%] flex flex-row items-center justify-between">
          <button
            className="p-4"
            onClick={() => {
              setPerson(null);
              setData(null);
              setOpenStatByModal(false);
            }}
          >
            <ClearOutlinedIcon />
          </button>
          {/* <Link
            className="p-4 text-[16px] flex gap-[14px]"
            to={"/fx/edit"}
            onClick={() => {
              setOpenStatByModal(false);
            }}
          >
            <BorderColorIcon />
          </Link> */}
        </div>
        <h1
          onDoubleClick={() => {
            setOpenPersonEdit(true);
          }}
          class="text-2xl font-bold mb-4 text-center uppercase"
        >
          {data?.name}
        </h1>
        <CustomModal openModal={openPersonEdit}>
          {loading ? <Loading /> : <></>}
          <div className="w-[100%] flex flex-row items-center justify-between">
            <button
              className="p-4"
              onClick={() => {
                // setEditAbleProduct(null);
                // setProducts(null);
                setOpenPersonEdit(false);
              }}
            >
              <ClearOutlinedIcon />
            </button>
          </div>
          <div className="max-w-[900px] w-[100%] m-auto mt-0 pt-[100px]">
            <h2 className="text-[red] text-[40px] text-center font-bold">
              ISmni o'zgartirish
            </h2>
            <div className="w-[100%] flex flex-col items-center gap-[14px]">
              <div class="w-[100%]">
                <label
                  for="input-with-helper-text"
                  class="block text-sm font-medium text-gray-700"
                >
                  isimni yozing
                </label>
                <input
                  type="text"
                  value={userNameEdit}
                  onChange={(e) => {
                    setOpenPersonEdit(e.target.value);
                  }}
                  id="input-with-helper-text"
                  class="mt-1 block w-[100%] px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  placeholder="Enter text"
                />
              </div>

              <button
                onClick={() => {
                  if (userNameEdit.length > 0) {
                    AddToSumFunc();
                  }
                }}
                class="w-[100%] bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              >
                O'zgartirish
              </button>
            </div>
          </div>
        </CustomModal>
        <div>
          <h2 className="font-bold">INN: {data?.INN ? data?.INN : 0} </h2>
          <h2 className="font-bold">Tel: {data?.phone ? data?.phone : 0} </h2>
          <p className="font-bold">
            Izox: {data?.comment ? data?.comment : 0}{" "}
          </p>
          <br />
          <h2 className="font-bold">
            Berdi:
            {data?.summa_bergan.length
              ? data?.summa_bergan.map((sum) => {
                  return (
                    <p className="p-0 m-1">
                      {" "}
                      sana: {sum.date} -- summa: {sum.summa?.toLocaleString()}
                    </p>
                  );
                })
              : 0}
          </h2>
          <h2 className="text-[red] font-bold">
            <p>
              Jami berdi:{"  "}
              {data?.summa_bergan.length
                ? data?.summa_bergan
                    .reduce((acc, curr) => {
                      return acc + curr?.summa;
                    }, 0)
                    ?.toLocaleString()
                : 0}{" "}
            </p>
            Qoldi:{" "}
            {data?.summa_qolgan ? data?.summa_qolgan?.toLocaleString() : 0} sum
          </h2>
          <IconButton
            onClick={() => {
              setOpenAddSum(true);
            }}
            aria-label="print"
            color="primary"
          >
            <AddCircleOutlineIcon />
          </IconButton>
          <CustomModal openModal={openAddSum}>
            {loading ? <Loading /> : <></>}
            <div className="w-[100%] flex flex-row items-center justify-between">
              <button
                className="p-4"
                onClick={() => {
                  // setEditAbleProduct(null);
                  // setProducts(null);
                  setOpenAddSum(false);
                }}
              >
                <ClearOutlinedIcon />
              </button>
            </div>
            <div className="max-w-[900px] w-[100%] m-auto mt-0 pt-[100px]">
              <h2 className="text-[red] text-[40px] text-center font-bold">
                Summa qo'shish
              </h2>
              <div className="w-[100%] flex flex-col items-center gap-[14px]">
                <div class="w-[100%]">
                  <label
                    for="input-with-helper-text"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Berilgan summani yozing
                  </label>
                  <input
                    type="number"
                    value={addSum}
                    onChange={(e) => {
                      setAddSum(Number(e.target.value));
                    }}
                    id="input-with-helper-text"
                    class="mt-1 block w-[100%] px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder="Enter text"
                  />
                </div>

                <button
                  onClick={() => {
                    if (addSum) {
                      AddToSumFunc();
                    }
                  }}
                  class="w-[100%] bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                  Summani qo'shish
                </button>
              </div>
            </div>
          </CustomModal>
        </div>
      </div>
      <div className="pb-[100px]">
        <div className="flex flex-col md:flex-row items-end justify-end p-4">
          {/* qidirish */}

          <div className="flex items-center justify-center">
            <IconButton
              onClick={handleFullscreen}
              aria-label="print"
              color="primary"
            >
              <OpenInFullIcon />
            </IconButton>
            <IconButton
              onClick={handlePrint}
              aria-label="print"
              color="primary"
            >
              <LocalPrintshopIcon />
            </IconButton>
            <IconButton
              // onClick={() => {
              //   setOpenModal(true);
              // }}
              aria-label="print"
              color="primary"
            >
              <TrendingUpIcon />
            </IconButton>
          </div>
        </div>
        <div ref={elementRef}>
          {data?.products ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 1200 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Nomi</TableCell>
                    <TableCell align="left">Qop</TableCell>
                    <TableCell align="left">Tn</TableCell>
                    <TableCell align="left">Narxi</TableCell>
                    <TableCell align="left">Auto number</TableCell>
                    <TableCell align="left">Berib yubordi</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">qayerdan</TableCell>
                    <TableCell align="left">sana</TableCell>
                    <TableCell align="left">izox</TableCell>
                    <TableCell align="left">Yozdi</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.products?.map((row) => (
                    <TableRow
                      onDoubleClick={() => {
                        setEditAbleProduct(null);
                        setEditAbleProduct(row);
                        setOpenProductEdit(true);
                      }}
                      key={row.name}
                      sx={{
                        cursor: "pointer",
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="left">
                        {row.qop?.toLocaleString()}
                      </TableCell>
                      <TableCell align="left">
                        {row.tonna?.toLocaleString()}
                      </TableCell>
                      <TableCell align="left">
                        {row.price_qop_sell?.toLocaleString()}
                      </TableCell>
                      <TableCell align="left">{row.auto_number}</TableCell>
                      <TableCell align="left">{row.given_by}</TableCell>
                      <TableCell align="left">{row.status}</TableCell>
                      <TableCell align="left">{row.from_to}</TableCell>
                      <TableCell align="left">{row.date}</TableCell>
                      <TableCell align="left">
                        <Tooltip title={row?.comment} color="blue">
                          {row?.comment}
                        </Tooltip>
                      </TableCell>
                      <TableCell align="left">{row.written_by}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <></>
          )}
        </div>
      </div>
    </CustomModal>
  );
}
